import * as React from 'react';

import {
  ECoworkingOfferType,
  IAgentSchema,
  IBusinessShoppingCenterSchema,
  IKPSchema,
  IOfferSchema,
} from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { Link } from '../../common/components/link';
import { trackKPLinkClick } from '../../utils/countrySideCardIntegrationTracking';
import {
  getCommercialAreaForMultiAds,
  getCommercialBuildingClass,
  getOfferTitle,
  getSquareInformation,
} from '../../utils/offer_helpers';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { pluralize } from '../../utils/pluralize';
import * as styles from './index.css';

export interface IOfferTitleProps {
  businessShoppingCenter: IBusinessShoppingCenterSchema | null;
  offer: IOfferSchema;
  isCountrysideCardIntegrated: boolean;
  agent: IAgentSchema | null;
  kp: IKPSchema | null;
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-150860, будет удалён в задаче CD-151061
   */
  isCommercialMultiAdsEnabled: boolean;
  isCommercialOfferWithMultiAds: boolean;
}

export class OfferTitle extends React.PureComponent<IOfferTitleProps, {}> {
  public render() {
    const { isCountrysideCardIntegrated, kp } = this.props;

    return (
      <div className={styles['container']}>
        <h1 className={styles['title']}>
          {this.getTitle()}
          {isCountrysideCardIntegrated && kp && <> в посёлке {this.renderIntegratedKpLink(kp)}</>}
        </h1>
      </div>
    );
  }

  private handleClick = () => {
    const { offer, agent, kp } = this.props;
    trackKPLinkClick('card_name_kp_in_newlist', offer, agent, kp && kp.id);
  };

  private getTitle = (): string => {
    const { businessShoppingCenter, offer, isCommercialMultiAdsEnabled, isCommercialOfferWithMultiAds } = this.props;
    /**
     * @todo Удалить "isCommercialMultiAdsEnabled"
     * @description Данный функционал появился в задаче CD-150860, будет удалён в задаче CD-151061
     */
    const isCommercialMultiAds = isCommercialMultiAdsEnabled && isCommercialOfferWithMultiAds;

    const offerType = getOfferType(offer);
    const commercialBuildingClass = getCommercialBuildingClass(offer.building, businessShoppingCenter);
    let title = getOfferTitle(offer);
    const squareInformation = getSquareInformation(offer);
    const multiAdsSquareInformation = getCommercialAreaForMultiAds(offer.minArea, offer.maxArea);

    if (offer.coworkingOfferType) {
      return this.getFormattedCoworkingTitle(title, squareInformation);
    }

    if (isCommercial(offerType) && commercialBuildingClass) {
      title += ` ${commercialBuildingClass}`;
    }

    if (isCommercialMultiAds && multiAdsSquareInformation) {
      title += `, ${multiAdsSquareInformation}`;
    }

    if (!isCommercialMultiAds && squareInformation) {
      title += `, ${squareInformation}`;
    }

    return title;
  };

  private readonly getFormattedCoworkingTitle = (title: string, squareInformation: string): string => {
    const { workplaceCount, coworkingOfferType } = this.props.offer;

    switch (coworkingOfferType) {
      case ECoworkingOfferType.Office: {
        const workplaces = workplaceCount ? `на ${workplaceCount} чел.` : '';

        return [title, squareInformation, workplaces].filter(Boolean).join(' ');
      }

      case ECoworkingOfferType.FixedWorkplace: {
        if (workplaceCount) {
          return pluralize(workplaceCount, [
            'закреплённое рабочее место',
            'закреплённых рабочих места',
            'закреплённых рабочих мест',
          ]);
        }

        return title;
      }

      case ECoworkingOfferType.FlexibleWorkplace: {
        if (workplaceCount) {
          return pluralize(workplaceCount, [
            'незакреплённое рабочее место',
            'незакреплённых рабочих места',
            'незакреплённых рабочих мест',
          ]);
        }

        return title;
      }

      default:
        return title;
    }
  };

  private renderIntegratedKpLink = (kp: IKPSchema) =>
    kp.url ? (
      <Link className={styles['link']} href={kp.url} target="_blank" rel="noopener" onClick={this.handleClick}>
        «{kp.name}»
      </Link>
    ) : (
      <span>«{kp.name}»</span>
    );
}
